export default __webpack_public_path__ + "static/media/02_photo.2972bb77.jpg";